export default __webpack_public_path__ + "static/media/category3.23a14dc5.png";